// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leave-container {
  margin: 0 3%;
  padding: 0%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Header */
.leave-header {
  width: 100%;
  margin: 2%;
  font-size: large;
  display: flex;
  justify-content: flex-start;
}

/* Filters Section */
.leave-filters {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 2%;
}

.leave-filters label {
  font-size: medium;
}

/* Date Inputs */
.date-filter-input {
  margin: 2% 0;
  padding: 1%;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 15%;
  font-size: large;
}

/* Buttons: Filter & Leave Form */
.filter-button,
.leave-form-button {
  margin-left: auto;
  padding: 1%;
  font-size: 100%;
  cursor: pointer;
  width: 15%;
  background-color: #00468c;
  color: white;
  border: none;
  border-radius: 5px;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.filter-button:hover,
.leave-form-button:hover {
  background-color: #003366;
  opacity: 0.9;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.filter-button:active,
.leave-form-button:active {
  transform: scale(0.98);
}

.filter-button:focus,
.leave-form-button:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

/* Save Button */
.leave-save {
  background-color: #7ac142;
  color: white;
  font-size: medium;
  padding: 1%;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
  width: 25%;
}

.leave-save:hover {
  background-color: #69a535;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.leave-save:active {
  transform: scale(0.98);
}

.leave-save:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

/* Cancel Button */
.leave-cancel {
  border: 1px solid #7ac142;
  background-color: white;
  color: #7ac142;
  font-size: medium;
  padding: 1%;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
  width: 25%;
}

.leave-cancel:hover {
  background-color: #f2f2f2;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.leave-cancel:active {
  transform: scale(0.98);
}

.leave-cancel:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.leave-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.leave-modal-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #7b7a7a;
  max-height: 84vh;
  width: 60%;
  padding: 0%;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Form */
.leave-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: #e8e9ea;
  padding: 0;
  border: 1px solid #ccc;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.leave-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  background-color: #00468c;
  padding: 1% 2%;
}

.leave-form-header h2 {
  margin: 1%;
  text-align: left;
  color: #ffffff;
}

.leave-form-header .icon {
  cursor: pointer;
  font-size: 150%;
}

.leave-form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(30%, 1fr));
  gap: 2%;
  padding: 2%;
  margin: 0;
}

.leave-form-group {
  margin-top: 2%;
  padding: 5%;
}

.leave-form label {
  display: block;
  margin-bottom: 2%;
  font-size: medium;
  font-weight: bold;
}

.leave-form input {
  padding: 5%;
  margin: 2%;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 80%;
  font-size: large;
}

.leave-form select {
  padding: 5%;
  margin: 2%;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 80%;
  font-size: medium;
}

.leave-form label:after {
  content: " *";
  color: red;
  font-size: large;
}

/* Buttons - Bottom Right */
.leave-form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10%;
  padding: 5%;
  grid-column: span 3;
}

/* Table Container */
.leave-request-table {
  height: 500px;
  overflow-y: auto;
  overflow-x: auto;
  margin-bottom: 5%;
  width: 100%;
}

.leave-requests {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
}

.my-leaves {
  width: 100%;
  text-align: left;
  margin: 1%;
}

/* Table */
.leave-requests th {
  border: 2px solid #cccbce;
  height: 5%;
  padding: 1%;
  background-color: #f2f2f2;
  font-size: medium;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.leave-requests td {
  border: 1px solid #cccbce;
  padding: 0.5% 1%;
  text-align: center;
  font-size: medium;
}

.leave-requests tr {
  background-color: #fff;
}

.leave-status-label {
  padding: 6px 12px;
  border-radius: 12px;
  display: inline-block;
  text-align: center;
  min-width: 80px;
}

.leave-approved {
  background-color: #d7f2ce;
}

.leave-rejected {
  background-color: #ffe5d2;
}

.action-button {
  font-size: x-large;
  margin: 0 5%;
}

/* Edit & Delete Buttons */
.button-edit,
.button-delete {
  font-size: x-large;
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.3s ease;
}

.button-edit {
  margin-right: 5%;
}

.button-edit:hover,
.button-delete:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.button-edit:active,
.button-delete:active {
  transform: scale(0.95);
}

.button-edit:focus,
.button-delete:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

/* Disabled styling for any element with .disabled */
.disabled {
  color: lightgray !important;
  pointer-events: none;
  cursor: not-allowed;
}

/* Hide table on mobile */
@media (max-width: 768px) {
  .desktop-view {
    display: none;
  }
  .mobile-view {
    display: block;
  }
}

/* Hide cards on desktop */
@media (min-width: 769px) {
  .mobile-view {
    display: none;
  }
}

/* Card Layout Styling */
.leave-card {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin: 10px 0;
  padding: 15px;
  transition: 0.3s;
  margin-bottom: 25px;
}

.leave-header {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  margin-bottom: 10px;
}

.leave-type {
  font-size: 16px;
  color: #333;
}

.leave-approved {
  background: #d7f2ce;
  color: #2e7d32;
}

.leave-rejected {
  background: #ffe5d2;
  color: #d32f2f;
}

.leave-details p {
  margin: 5px 0;
  font-size: 14px;
  color: #555;
}

.leave-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

.action-button {
  font-size: 20px;
  cursor: pointer;
  color: #333;
}

.action-button.disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* Mobile View */
@media (max-width: 768px) {
  /* Container */
  .leave-container {
    margin: 8%;
    align-items: stretch;
  }

  /* Header */
  .leave-header {
    font-size: medium;
    text-align: start;
  }

  /* Filters Section */
  .leave-filters {
    flex-direction: column;
    align-items: stretch;
    gap: 5px;
  }

  .leave-filters label {
    font-size: small;
  }

  /* Date Inputs */
  .date-filter-input {
    width: 94%;
    font-size: medium;
    padding: 10px;
  }

  /* Buttons */
  .filter-button,
  .leave-form-button {
    width: 100%;
    font-size: medium;
    padding: 10px;
  }

  /* Leave Modal */
  .leave-modal-content {
    width: 90%;
    max-height: 90vh;
  }

  /* Leave Form */
  .leave-form {
    padding: 5%;
  }

  .leave-form-header {
    flex-direction: column;
    text-align: center;
  }

  /* Grid Adjustments */
  .leave-form-grid {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .leave-form-group {
    width: 100%;
    padding: 0;
  }

  .leave-form label {
    font-size: small;
  }

  .leave-form input,
  .leave-form select {
    width: 100%;
    padding: 10px;
    font-size: small;
  }

  /* Buttons - Bottom Section */
  .leave-form-actions {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }

  .leave-save,
  .leave-cancel {
    width: 100%;
    font-size: medium;
  }

  /* Table */
  .leave-request-table {
    height: auto;
    overflow-x: scroll;
    width: 100%;
  }

  .leave-requests {
    font-size: small;
  }
}

/* Responsive */
@media (max-width: 768px) {
  /* Header Section */
  .leave-form-header {
    align-items: flex-start;
    color: white;
    background-color: #00468c;
    padding: 10px 15px;
  }

  .leave-form-header h2 {
    font-size: 1.2rem;
    margin: 0;
    margin-top: 4%;
  }

  .leave-form-header .icon {
    cursor: pointer;
    font-size: 1.5rem;
    margin-left: auto;
    margin-top: -8%;
  }

  /* Leave Form Grid */
  .leave-form-grid {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 15px;
    margin-left: 0;
  }

  .leave-form-group {
    margin-top: 0;
    padding: 0;
    width: 100%;
  }

  /* Form Actions */
  .leave-form-actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 15px 10px;
    gap: 85px;
    width: 90%;
  }

  /* Leave Table */
  .leave-requests th,
  .leave-requests td {
    font-size: 0.9rem;
    padding: 10px;
    text-align: left;
  }

  /* Label Adjustments */
  .leave-status-label {
    margin-left: 50%;
  }

  /* My Leaves Section */
  .my-leaves {
    width: 100%;
    text-align: left;
    margin: 4%;
  }

  /* Buttons (Equal Size) */
  .filter-button,
  .leave-form-button,
  .leave-save,
  .leave-cancel {
    width: 100%; /* Equal width for buttons */
    padding: 12px;
    font-size: 1rem;
    margin-bottom: 10px;
    text-align: center; /* Align text in center */
    box-sizing: border-box;
  }

  /* Responsive Input/Select (Equal Size) */
  .leave-form input,
  .leave-form select {
    width: 100%;
    padding: 12px;
    font-size: 1rem;
    margin: 0;
    box-sizing: border-box;
  }

  /* Date Filter Inputs (Equal Size) */
  .date-filter-input {
    width: 100%;
    padding: 12px;
    font-size: 1rem;
    margin: 0;
    box-sizing: border-box;
  }

  /* Modal */
  .leave-modal-content {
    width: 95%;
    padding: 10px;
    box-sizing: border-box;
  }

  .leave-container {
    height: 100vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LeaveQueries/LeaveRequest.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;;EAEE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB;wBACsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB;wBACsB;EACtB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB;wBACsB;EACtB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,sBAAsB;EACtB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,UAAU;EACV,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,OAAO;EACP,WAAW;EACX,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;;EAEE,kBAAkB;EAClB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;EACf;AACF;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA,WAAW;EACX;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,oBAAoB;EACpB;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;EACf;;EAEA,YAAY;EACZ;;IAEE,WAAW;IACX,iBAAiB;IACjB,aAAa;EACf;;EAEA,gBAAgB;EAChB;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA,eAAe;EACf;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,qBAAqB;EACrB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA,6BAA6B;EAC7B;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,iBAAiB;EACnB;;EAEA,UAAU;EACV;IACE,YAAY;IACZ,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB;IACE,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;EACjB;;EAEA,oBAAoB;EACpB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,WAAW;EACb;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;;EAEA,gBAAgB;EAChB;;IAEE,iBAAiB;IACjB,aAAa;IACb,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,WAAW;IACX,gBAAgB;IAChB,UAAU;EACZ;;EAEA,yBAAyB;EACzB;;;;IAIE,WAAW,EAAE,4BAA4B;IACzC,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,kBAAkB,EAAE,yBAAyB;IAC7C,sBAAsB;EACxB;;EAEA,yCAAyC;EACzC;;IAEE,WAAW;IACX,aAAa;IACb,eAAe;IACf,SAAS;IACT,sBAAsB;EACxB;;EAEA,oCAAoC;EACpC;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,SAAS;IACT,sBAAsB;EACxB;;EAEA,UAAU;EACV;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".leave-container {\n  margin: 0 3%;\n  padding: 0%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Header */\n.leave-header {\n  width: 100%;\n  margin: 2%;\n  font-size: large;\n  display: flex;\n  justify-content: flex-start;\n}\n\n/* Filters Section */\n.leave-filters {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  gap: 2%;\n}\n\n.leave-filters label {\n  font-size: medium;\n}\n\n/* Date Inputs */\n.date-filter-input {\n  margin: 2% 0;\n  padding: 1%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 15%;\n  font-size: large;\n}\n\n/* Buttons: Filter & Leave Form */\n.filter-button,\n.leave-form-button {\n  margin-left: auto;\n  padding: 1%;\n  font-size: 100%;\n  cursor: pointer;\n  width: 15%;\n  background-color: #00468c;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.filter-button:hover,\n.leave-form-button:hover {\n  background-color: #003366;\n  opacity: 0.9;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.filter-button:active,\n.leave-form-button:active {\n  transform: scale(0.98);\n}\n\n.filter-button:focus,\n.leave-form-button:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n/* Save Button */\n.leave-save {\n  background-color: #7ac142;\n  color: white;\n  font-size: medium;\n  padding: 1%;\n  border: none;\n  cursor: pointer;\n  border-radius: 5px;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n  width: 25%;\n}\n\n.leave-save:hover {\n  background-color: #69a535;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.leave-save:active {\n  transform: scale(0.98);\n}\n\n.leave-save:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n/* Cancel Button */\n.leave-cancel {\n  border: 1px solid #7ac142;\n  background-color: white;\n  color: #7ac142;\n  font-size: medium;\n  padding: 1%;\n  cursor: pointer;\n  border-radius: 5px;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n  width: 25%;\n}\n\n.leave-cancel:hover {\n  background-color: #f2f2f2;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.leave-cancel:active {\n  transform: scale(0.98);\n}\n\n.leave-cancel:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.leave-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.leave-modal-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color: #7b7a7a;\n  max-height: 84vh;\n  width: 60%;\n  padding: 0%;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n/* Form */\n.leave-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  background-color: #e8e9ea;\n  padding: 0;\n  border: 1px solid #ccc;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.leave-form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: white;\n  background-color: #00468c;\n  padding: 1% 2%;\n}\n\n.leave-form-header h2 {\n  margin: 1%;\n  text-align: left;\n  color: #ffffff;\n}\n\n.leave-form-header .icon {\n  cursor: pointer;\n  font-size: 150%;\n}\n\n.leave-form-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(30%, 1fr));\n  gap: 2%;\n  padding: 2%;\n  margin: 0;\n}\n\n.leave-form-group {\n  margin-top: 2%;\n  padding: 5%;\n}\n\n.leave-form label {\n  display: block;\n  margin-bottom: 2%;\n  font-size: medium;\n  font-weight: bold;\n}\n\n.leave-form input {\n  padding: 5%;\n  margin: 2%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 80%;\n  font-size: large;\n}\n\n.leave-form select {\n  padding: 5%;\n  margin: 2%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 80%;\n  font-size: medium;\n}\n\n.leave-form label:after {\n  content: \" *\";\n  color: red;\n  font-size: large;\n}\n\n/* Buttons - Bottom Right */\n.leave-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10%;\n  padding: 5%;\n  grid-column: span 3;\n}\n\n/* Table Container */\n.leave-request-table {\n  height: 500px;\n  overflow-y: auto;\n  overflow-x: auto;\n  margin-bottom: 5%;\n  width: 100%;\n}\n\n.leave-requests {\n  table-layout: fixed;\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.my-leaves {\n  width: 100%;\n  text-align: left;\n  margin: 1%;\n}\n\n/* Table */\n.leave-requests th {\n  border: 2px solid #cccbce;\n  height: 5%;\n  padding: 1%;\n  background-color: #f2f2f2;\n  font-size: medium;\n  font-weight: bold;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.leave-requests td {\n  border: 1px solid #cccbce;\n  padding: 0.5% 1%;\n  text-align: center;\n  font-size: medium;\n}\n\n.leave-requests tr {\n  background-color: #fff;\n}\n\n.leave-status-label {\n  padding: 6px 12px;\n  border-radius: 12px;\n  display: inline-block;\n  text-align: center;\n  min-width: 80px;\n}\n\n.leave-approved {\n  background-color: #d7f2ce;\n}\n\n.leave-rejected {\n  background-color: #ffe5d2;\n}\n\n.action-button {\n  font-size: x-large;\n  margin: 0 5%;\n}\n\n/* Edit & Delete Buttons */\n.button-edit,\n.button-delete {\n  font-size: x-large;\n  cursor: pointer;\n  transition: transform 0.1s ease, box-shadow 0.3s ease;\n}\n\n.button-edit {\n  margin-right: 5%;\n}\n\n.button-edit:hover,\n.button-delete:hover {\n  transform: scale(1.05);\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.button-edit:active,\n.button-delete:active {\n  transform: scale(0.95);\n}\n\n.button-edit:focus,\n.button-delete:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n/* Disabled styling for any element with .disabled */\n.disabled {\n  color: lightgray !important;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\n/* Hide table on mobile */\n@media (max-width: 768px) {\n  .desktop-view {\n    display: none;\n  }\n  .mobile-view {\n    display: block;\n  }\n}\n\n/* Hide cards on desktop */\n@media (min-width: 769px) {\n  .mobile-view {\n    display: none;\n  }\n}\n\n/* Card Layout Styling */\n.leave-card {\n  background: #fff;\n  border-radius: 5px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  margin: 10px 0;\n  padding: 15px;\n  transition: 0.3s;\n  margin-bottom: 25px;\n}\n\n.leave-header {\n  display: flex;\n  justify-content: space-between;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.leave-type {\n  font-size: 16px;\n  color: #333;\n}\n\n.leave-approved {\n  background: #d7f2ce;\n  color: #2e7d32;\n}\n\n.leave-rejected {\n  background: #ffe5d2;\n  color: #d32f2f;\n}\n\n.leave-details p {\n  margin: 5px 0;\n  font-size: 14px;\n  color: #555;\n}\n\n.leave-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.action-button {\n  font-size: 20px;\n  cursor: pointer;\n  color: #333;\n}\n\n.action-button.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n/* Mobile View */\n@media (max-width: 768px) {\n  /* Container */\n  .leave-container {\n    margin: 8%;\n    align-items: stretch;\n  }\n\n  /* Header */\n  .leave-header {\n    font-size: medium;\n    text-align: start;\n  }\n\n  /* Filters Section */\n  .leave-filters {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 5px;\n  }\n\n  .leave-filters label {\n    font-size: small;\n  }\n\n  /* Date Inputs */\n  .date-filter-input {\n    width: 94%;\n    font-size: medium;\n    padding: 10px;\n  }\n\n  /* Buttons */\n  .filter-button,\n  .leave-form-button {\n    width: 100%;\n    font-size: medium;\n    padding: 10px;\n  }\n\n  /* Leave Modal */\n  .leave-modal-content {\n    width: 90%;\n    max-height: 90vh;\n  }\n\n  /* Leave Form */\n  .leave-form {\n    padding: 5%;\n  }\n\n  .leave-form-header {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  /* Grid Adjustments */\n  .leave-form-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .leave-form-group {\n    width: 100%;\n    padding: 0;\n  }\n\n  .leave-form label {\n    font-size: small;\n  }\n\n  .leave-form input,\n  .leave-form select {\n    width: 100%;\n    padding: 10px;\n    font-size: small;\n  }\n\n  /* Buttons - Bottom Section */\n  .leave-form-actions {\n    flex-direction: column;\n    gap: 10px;\n    align-items: stretch;\n  }\n\n  .leave-save,\n  .leave-cancel {\n    width: 100%;\n    font-size: medium;\n  }\n\n  /* Table */\n  .leave-request-table {\n    height: auto;\n    overflow-x: scroll;\n    width: 100%;\n  }\n\n  .leave-requests {\n    font-size: small;\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  /* Header Section */\n  .leave-form-header {\n    align-items: flex-start;\n    color: white;\n    background-color: #00468c;\n    padding: 10px 15px;\n  }\n\n  .leave-form-header h2 {\n    font-size: 1.2rem;\n    margin: 0;\n    margin-top: 4%;\n  }\n\n  .leave-form-header .icon {\n    cursor: pointer;\n    font-size: 1.5rem;\n    margin-left: auto;\n    margin-top: -8%;\n  }\n\n  /* Leave Form Grid */\n  .leave-form-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    padding: 15px;\n    margin-left: 0;\n  }\n\n  .leave-form-group {\n    margin-top: 0;\n    padding: 0;\n    width: 100%;\n  }\n\n  /* Form Actions */\n  .leave-form-actions {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 10px;\n    gap: 85px;\n    width: 90%;\n  }\n\n  /* Leave Table */\n  .leave-requests th,\n  .leave-requests td {\n    font-size: 0.9rem;\n    padding: 10px;\n    text-align: left;\n  }\n\n  /* Label Adjustments */\n  .leave-status-label {\n    margin-left: 50%;\n  }\n\n  /* My Leaves Section */\n  .my-leaves {\n    width: 100%;\n    text-align: left;\n    margin: 4%;\n  }\n\n  /* Buttons (Equal Size) */\n  .filter-button,\n  .leave-form-button,\n  .leave-save,\n  .leave-cancel {\n    width: 100%; /* Equal width for buttons */\n    padding: 12px;\n    font-size: 1rem;\n    margin-bottom: 10px;\n    text-align: center; /* Align text in center */\n    box-sizing: border-box;\n  }\n\n  /* Responsive Input/Select (Equal Size) */\n  .leave-form input,\n  .leave-form select {\n    width: 100%;\n    padding: 12px;\n    font-size: 1rem;\n    margin: 0;\n    box-sizing: border-box;\n  }\n\n  /* Date Filter Inputs (Equal Size) */\n  .date-filter-input {\n    width: 100%;\n    padding: 12px;\n    font-size: 1rem;\n    margin: 0;\n    box-sizing: border-box;\n  }\n\n  /* Modal */\n  .leave-modal-content {\n    width: 95%;\n    padding: 10px;\n    box-sizing: border-box;\n  }\n\n  .leave-container {\n    height: 100vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
